import Box from './Box';
import Circle from './Circle';
import Paragraph from './Paragraph';

const Skeleton = {
  Box,
  Circle,
  Paragraph,
};

export default Skeleton;
